import React from 'react';
import styles from './RestoreDeletedClinic.module.scss';

import {TbTrashOff} from 'react-icons/tb';
import api from '../../../helpers/api';
import {$t} from '../../../helpers/translator';
import Modal from '../../miscellaneous/Modal/Modal';
import {setAlert} from "../../../store/alerts-slice";
import {connect} from "react-redux";


class RestoreDeletedClinic extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };
    }

    presentApprovalModal() {
        this.setState({showModal: true}, () => {
            // console.log(this.state)
        });
    }

    closeModals() {
        this.setState({showModal: false});
    }

    async returnClinic() {
        try {
            let res = await api.post(`clinic/restore-clinic/${this.props.id}`);
            if (res && res.data && res.data.success) {
                this.props.dispatch(setAlert({type: 'success', body: $t('global.clinics.restoreSuccessMessage')}));
                this.props.onSuccess({success: true});
                this.setState({showModal: false});
            }
        } catch (e) {
            this.props.dispatch(setAlert({type: 'error'}));
            console.error('err deleting:', e);
        }
    }

    renderContent() {
        return (
            <div className={`${styles['delete-container']}`}>
                <div className={`${styles['first-row']}`}>
                    {$t('global.clinics.restoreClinic')}
                </div>
                <div className={`${styles['second-row']}`}>
                    {this.props.id ?
                        <div>
                            <span
                                style={{fontWeight: '300'}}>{$t('global.clinics.clinicId')}:</span> {this.props.id}
                        </div>
                        :
                        null
                    }
                    {this.props.clinicName ?
                        <div>
                            <span
                                style={{fontWeight: '300'}}>{$t('global.clinics.clinicName')}:</span> {this.props.clinicName}
                        </div>
                        :
                        null
                    }
                </div>

                <div className={`${styles['third-row']}`}>
                    {$t('global.clinics.restoreThisClinic')}
                </div>
                <div className={`${styles['delete-approve']}`}>
                    <div className={`${styles['delete-button']}`}
                         onClick={() => this.returnClinic()}>{$t('global.clinics.restore')}</div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className={`${styles['container']}`} style={this.props.style ? this.props.style : null}>
                <TbTrashOff className={`${styles['icon']}`} onClick={() => this.presentApprovalModal()}/>

                <Modal content={this.renderContent()}
                       onClose={this.closeModals.bind(this)}
                       visible={this.state.showModal}/>
            </div>
        );
    }
}

// export default RestoreDeletedClinic;
const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(RestoreDeletedClinic);